export function getAuthHeader() {
	const token = sessionStorage.getItem('hefestoAccessToken');
	return {
		Authorization: token ? `Bearer ${token}` : '',
	};
}
